module.exports = __webpack_public_path__ + "static/media/icon-compra.7d4dafa1.svg";